<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'NavBar',
})
</script>
<template>
  <div>
    <NavBar
      :title="title"
      :fixed="fixed"
      :left-text="leftText"
      :left-arrow="leftArrow"
      :border="false"
      :class="[transparent ? 'transparent-nav' : '']"
      z-index="500"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #title>
        <span v-if="showTitle">
          {{ title }}
        </span>
        <slot v-else name="title"> </slot>
      </template>
      <template #right>
        <slot name="right"> </slot>
      </template>
    </NavBar>
  </div>
</template>
<script setup lang="ts" name="NavBar">
import { NavBar } from 'vant'
import { useRouter } from 'vue-router'
import { nativeBack } from '@/utils/native'
import { useUserStore } from '@/stores/user'

interface IProps {
  title?: string
  leftText?: string
  leftArrow?: boolean
  fixed?: boolean
  selfClick?: boolean
  showTitle?: boolean
  transparent?: boolean // 透明属性设置
}

const { userInfo } = useUserStore()
const { safeArea } = userInfo

const safeAreaTop = `${safeArea.top}px`

const router = useRouter()

const props = withDefaults(defineProps<IProps>(), {
  title: '',
  leftText: '',
  leftArrow: true,
  fixed: false,
  selfClick: false,
  showTitle: true,
  transparent: false
})

const emit = defineEmits<{
  (event: 'goBack'): void
  (event: 'rightClick'): void
}>()

const onClickLeft = () => {
  if (!props.selfClick) {
    const isApp = router.currentRoute.value.meta?.isApp
    if (isApp) {
      nativeBack()
    } else {
      router.go(-1)
    }
  }
  emit('goBack')
}
const onClickRight = () => {
  emit('rightClick')
}
</script>

<style scoped lang="less">
// 基础样式
:deep(.van-nav-bar__content) {
  height: auto !important;
  background-color: #fff;
  padding-top: calc(12px + v-bind(safeAreaTop));
  padding-bottom: 12px;
}

:deep(.van-nav-bar__title) {
  color: #171921;
  font-weight: 500;
  font-size: 18px;
}
:deep(.van-nav-bar__left) {
  top: v-bind(safeAreaTop);
}
:deep(.van-nav-bar__right) {
  top: v-bind(safeAreaTop);
}

.van-nav-bar :deep(.van-icon) {
  font-size: 20px;
  color: #171921;
}

:deep(.van-nav-bar__text) {
  color: #171921;
}

// 透明导航栏样式
.transparent-nav {
  // 重要：覆盖 van-nav-bar 本身的背景色
  background-color: transparent;
}
.van-nav-bar.transparent-nav {
  :deep(.van-nav-bar),
  :deep(.van-nav-bar__content),
  :deep(.van-nav-bar__placeholder) {
    background-color: transparent;
  }
}

// 去除边框
:deep(.van-hairline--bottom::after) {
  border-bottom-width: 0;
}
</style>
